export default __webpack_public_path__ + "4260d5db8309a6f836373e11dea585de.svg";